import { cn } from "@/lib/utils";
import {
  EVERYTHING_ELSE_FREE_EXAMPLES,
  EVERYTHING_ELSE_FREE_LEAD,
} from "@repo/shared/credits";

/**
 * The line both credit dialogs close on.
 *
 * The lead-in carries the weight — it is the reassurance, and the examples are
 * only evidence for it — so it is the part that is emphasised. Shared rather
 * than repeated: the two copies had already come to disagree about whether
 * evolutions are free.
 */
export const EverythingElseFree = ({ className }: { className?: string }) => (
  <p className={className}>
    <span className={cn("font-bold text-foreground")}>
      {EVERYTHING_ELSE_FREE_LEAD}
    </span>{" "}
    {EVERYTHING_ELSE_FREE_EXAMPLES}
  </p>
);
